<template>
  <router-view />
</template>

<script>
export default {
  name: 'ProductStorageProductsIndex'
}
</script>
